import { render, staticRenderFns } from "./faculty-details.vue?vue&type=template&id=0f871a5d&scoped=true&"
import script from "./faculty-details.vue?vue&type=script&lang=js&"
export * from "./faculty-details.vue?vue&type=script&lang=js&"
import style0 from "./faculty-details.vue?vue&type=style&index=0&id=0f871a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f871a5d",
  null
  
)

export default component.exports